<nav class="list-group list-group-flush bg-secondary min-h-vh ">

  @if (showEvents) {
    <a
      [routerLinkActive]="['active']"
      [routerLink]="'/events'"
      class="list-group-item list-group-item-sidebar-secondary">
      <i class="fa-regular fa-calendar-check"></i>
      {{ 'sidebar.events' | translate }}
    </a>
  }

  <a
    *appIfHasAllPermissions="[PERMISSION.SPH_RESOURCES_SERVICEPROVIDER_SERVICEPROVIDERBUDGET_READ_ALL]"
    [routerLinkActive]="['active']"
    [routerLink]="'/budgets'"
    class="list-group-item list-group-item-sidebar-secondary">
    <i class="fa-solid fa-wallet"></i>
    {{ 'sidebar.budgets' | translate }}
  </a>

  <a
    [routerLinkActive]="['active']"
    [routerLink]="'/event-calendar'"
    class="list-group-item list-group-item-sidebar-secondary">
    <i class="fa-regular fa-calendar"></i>
    {{ 'sidebar.event_calendar' | translate }}
  </a>

  <a
    (click)="logout()"
    class="list-group-item list-group-item-sidebar">
    <i class="fa fa-external-link"></i> Logout
  </a>

</nav>
